import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "settings-panel" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { ref } from 'vue';
import type { Roles } from '@/types/game';

import RoleSettings from './RoleSettings.vue';
import EnvironmentSettings from './EnvironmentSettings.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsPanel',
  props: {
    initialRoles: {},
    initialEnvironment: {},
    isHost: { type: Boolean },
    playerCount: {},
    isLoading: { type: Boolean }
  },
  emits: ["update-roles", "update-environment"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const activeTab = ref<'roles' | 'environment'>('roles');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(['tab-btn', { active: activeTab.value === 'roles' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'roles'))
      }, " Настройки Ролей ", 2),
      _createElementVNode("button", {
        class: _normalizeClass(['tab-btn', { active: activeTab.value === 'environment' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'environment'))
      }, " Сеттинг Игры ", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (activeTab.value === 'roles')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(RoleSettings, {
              "initial-roles": _ctx.initialRoles,
              "is-host": _ctx.isHost,
              "player-count": _ctx.playerCount,
              onUpdateRoles: _cache[2] || (_cache[2] = ($event: any) => (emit('update-roles', $event)))
            }, null, 8, ["initial-roles", "is-host", "player-count"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'environment')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(EnvironmentSettings, {
              "initial-environment": _ctx.initialEnvironment,
              "is-host": _ctx.isHost,
              "is-loading": _ctx.isLoading,
              onUpdateEnvironment: _cache[3] || (_cache[3] = ($event: any) => (emit('update-environment', $event)))
            }, null, 8, ["initial-environment", "is-host", "is-loading"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})